(() => {
  const CHAT_TRIGGER = "[data-lunavia-chat-open]";
  const CALLBACK_TRIGGER = "[data-lunavia-callback-open]";

  function openChat(trigger) {
    const showAndOpenChat = () => {
      if (!window.tidioChatApi?.open) return false;

      window.tidioChatApi.show?.();
      window.tidioChatApi.open();
      return true;
    };

    if (window.tidioChatApi?.on) {
      window.tidioChatApi.on("ready", showAndOpenChat);
    } else {
      document.addEventListener("tidioChat-ready", showAndOpenChat, { once: true });
    }

    showAndOpenChat();

    trigger.setAttribute("aria-live", "polite");
  }

  function init(container = document) {
    container.querySelectorAll(CHAT_TRIGGER).forEach((trigger) => {
      if (trigger.dataset.lunaviaInitialized === "true") return;
      trigger.dataset.lunaviaInitialized = "true";
      trigger.addEventListener("click", () => openChat(trigger));
    });

    container.querySelectorAll(CALLBACK_TRIGGER).forEach((trigger) => {
      if (trigger.dataset.lunaviaInitialized === "true") return;
      trigger.dataset.lunaviaInitialized = "true";
      trigger.addEventListener("click", () => {
        document.dispatchEvent(new CustomEvent("lunavia:open-callback"));
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
